import { type GetDataIngestionSourcesResponse } from '../../../types';
import { getOverallDatasetsFreshnessStatus } from '../../utilities/get-overall-datasets-freshness-status';

import { getBatchFreshnessStatus } from './get-batch-freshness-status';

/**
 * Returns a combined freshness status considering both batch staleness
 * and overall datasets freshness.
 */
export const getBatchAndOverallDatasetsFreshnessStatus = (
  datasets: GetDataIngestionSourcesResponse['sources'],
  batchCreatedAt?: string,
) => {
  const batchStatus = getBatchFreshnessStatus(datasets, batchCreatedAt);
  const datasetsStatus = getOverallDatasetsFreshnessStatus(datasets);

  if (datasetsStatus === 'all_datasets_new') {
    return batchStatus;
  }
  return datasetsStatus;
};
